import React from "react";
import SpotifyWidget from "./SpotifyWidget";

export default function Footer() {
  return (
    <div>
    </div>
  );
}
